// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","footerSection1":"Footer_footerSection1__0FAT1","footerLinks":"Footer_footerLinks__Mudwb","footerSection2":"Footer_footerSection2__FbqIm"};